import { render } from "./AboutStyleTwo.vue?vue&type=template&id=54fb141d"
import script from "./AboutStyleTwo.vue?vue&type=script&lang=js"
export * from "./AboutStyleTwo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__